export default "__VITE_ASSET__BKZ59q$W__"